module.exports = __webpack_public_path__ + "fonts/TTNormsPro-Thin.f7caaa82.ttf";